import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  dashboardCell: {
    position: 'relative',
    height: '100%',
    '&:hover $configButton': {
      opacity: 1,
    },
  },
  configButton: {
    position: 'absolute !important',
    top: '12px',
    right: '12px',
    opacity: 0,
    zIndex: 10,
    transition: 'opacity 0.2s ease, background-color 0.2s, transform 0.2s !important',
    backgroundColor: theme.palette.type === 'dark' ? '#27272A !important' : '#F4F5F7 !important',
    color: `${theme.palette.text.secondary} !important`,
    padding: '6px !important',
    minWidth: 'auto !important',
    borderRadius: '50% !important',
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? '#3F3F46 !important' : '#E4E7EB !important',
      transform: 'rotate(45deg)',
    },
  },
  chartCard: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '12px',
    padding: theme.spacing(2.5),
    height: '100%',
    boxShadow: 'none',
  },
  chartTitle: {
    fontSize: '1.1rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: '2px',
    paddingRight: '32px',
  },
  chartSubtitle: {
    fontSize: '0.8rem',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  cellLoadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(14, 14, 14, 0.7)' : 'rgba(255, 255, 255, 0.7)',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 5,
  },
  noDataContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  noDataText: {
    color: theme.palette.text.secondary || '#888',
    fontStyle: 'italic',
  },
}))

export default useStyles
